import { useEffect, useState } from 'react';
import { obtenerMiGrupoConLogo, descargarLogoGrupo } from '../../services/Siniestro/SiniestroGrupoService';

const GeointSorisegHeader = ({ subtitle }) => {
    const [logoUrl, setLogoUrl] = useState(null);
    const [nombreGrupo, setNombreGrupo] = useState('');

    useEffect(() => {
        let blobUrlActual = null;
        let cancelado = false;

        const cargarLogoEmpresa = async () => {
            try {
                const grupo = await obtenerMiGrupoConLogo();
                if (cancelado || !grupo) return;
                const blob = await descargarLogoGrupo(grupo.siniestroGrupoId);
                if (cancelado || !blob) return;
                blobUrlActual = URL.createObjectURL(blob);
                setLogoUrl(blobUrlActual);
                setNombreGrupo(grupo.nombre || '');
            } catch (e) {
                // Sin logo en el header no es un error visible — fallback al icono original.
            }
        };
        cargarLogoEmpresa();

        return () => {
            cancelado = true;
            if (blobUrlActual) URL.revokeObjectURL(blobUrlActual);
        };
    }, []);

    return (
        <div
            className="flex align-items-center justify-content-between p-3 mb-3 border-round-xl shadow-2"
            style={{
                background: 'linear-gradient(90deg, #1565C0 0%, #0D47A1 100%)',
                borderLeft: '6px solid #facc15'
            }}
        >
            <div className="flex align-items-center gap-3">
                <img
                    src="assets/layout/images/Logo_Cema_Redondo.png"
                    alt="CEMA"
                    style={{ width: '48px', height: '48px' }}
                />
                <div className="flex flex-column">
                    <span
                        style={{
                            color: '#ffffff',
                            fontSize: '1.6rem',
                            fontWeight: 700,
                            letterSpacing: '1px',
                            lineHeight: 1.1
                        }}
                    >
                        CEMA
                    </span>
                    {subtitle && (
                        <span style={{ color: '#e5e7eb', fontSize: '0.85rem', marginTop: '2px' }}>
                            {subtitle}
                        </span>
                    )}
                </div>
            </div>
            {logoUrl ? (
                <img
                    src={logoUrl}
                    alt={nombreGrupo || 'Logo empresa'}
                    title={nombreGrupo}
                    style={{
                        maxHeight: '52px',
                        maxWidth: '180px',
                        objectFit: 'contain',
                        background: '#ffffff',
                        borderRadius: '8px',
                        padding: '4px'
                    }}
                />
            ) : (
                <i
                    className="pi pi-shield"
                    style={{ color: '#facc15', fontSize: '1.8rem' }}
                ></i>
            )}
        </div>
    );
};

export default GeointSorisegHeader;
